<div class="container">
  <mat-toolbar class="subnav d-flex flex-column flex-md-row justify-content-between">
    <div class="navlinks d-none d-lg-flex align-items-center justify-content-start justify-content-md-end">
      @for (link of links; track link) {
        <a class="textlink" [routerLink]="link.url" [class.active]="link.url === (currentRoute$ | async)">
          <span translate>{{ link.linktitle }}</span>
        </a>
      }
    </div>
    <div class="search-wrapper d-flex flex-row align-items-center">
      <app-trainings-search></app-trainings-search>
      <button mat-flat-button (click)="openTopicFilterDialog()">
        <!--FIXME: think of a generic, nice way of correctly aligning button-labels and icons e.g. via overwriting mdc-styles or using mat-icon in `inline`-mode?-->
        <div class="label-wrapper d-flex align-items-center">
          <!--TODO: added for scaffold, use correct custom icon-->
          <mat-icon svgIcon="troodi_filter_v2"></mat-icon>
          <span translate>FILTER.OPEN</span>
        </div>
      </button>
    </div>
  </mat-toolbar>
</div>
